import Konva from 'konva';

import { Element } from '../../equipment/models/elements/element';
import { IPlanogram } from './planogram';
import { konvaSettings } from '../../equipment/models/konvaSettings';
import { PlanogramViewBehavior } from './planogramViewBehavior';
import { Point } from '../../core/models/point';
import { ProductGroup } from './product-group';

import { Utils } from '../../core/services/utils.service';

export class PlanogramSideBehavior extends PlanogramViewBehavior {

	constructor(planogram: IPlanogram, detailedElement: Element, scale: number, beginPoint: Point) {
		super(planogram, detailedElement, scale, beginPoint);
	}

	public convertCanvasPointToPlanogram(point: Point): Point {
		const canvasZPoint: number = point.x - konvaSettings.detailedCanvasOffset - this.beginPoint.x;

		return {
			x: this.element.getBoundingX().min + this.element.Width / 2,
			y: this.element.getBoundingY().min + this.element.Height / 2,
			z: Utils.round(this.element.getBoundingZ().min + canvasZPoint / this.scale)
		};
	}

	public convertPlanogramPointToCanvas(point: Point): Point {
		return {
			x: Utils.round(point.z * this.scale + konvaSettings.detailedCanvasOffset + this.beginPoint.x),
			y: Utils.round(this.planogram.stand.Height - (point.y * this.scale + konvaSettings.detailedCanvasOffset + this.beginPoint.y))
		};
	}

	public getActiveProductGroups(activeProducts: Array<ProductGroup>): Array<Array<ProductGroup>> {
		return activeProducts
			.map((pg: ProductGroup) => [pg])
			.sort((a: Array<ProductGroup>, b: Array<ProductGroup>) => a[0].begin.z - b[0].begin.z);
	}

	public getAnchorElement(product: ProductGroup, point: Point): Element {
		return this.element;
	}

	public getCorrectZCoordinate(element: Element, z: number, product: ProductGroup): number {
		return z;
	}

	public getOffset(): Point {
		return {
			x: Math.min(
				this.element.getBoundingZ().min,
				...this.element.products.flat().map((pg: ProductGroup) => pg.getBoundingZ().min)
			),
			y: this.planogram.stand.Height - this.element.getBoundingY().min
		};
	}

	public getPoint(product: ProductGroup, canvasElement: Konva.Group): Point {
		const canvasXPoint: number = canvasElement.x() - konvaSettings.detailedCanvasOffset - this.beginPoint.x;

		return {
			x: product.begin.x,
			y: product.begin.y,
			z: Utils.round(this.element.getBoundingZ().min + canvasXPoint / this.scale + product.Depth)
		};
	}

	public getProductAngle(element: Element, point: Point): number {
		return 0;
	}

	public moveProducts(products: Array<ProductGroup>, horizontal: number, vertical: number): boolean {
		return false;
	}
}